import { useTranslation } from 'react-i18next'
import { Select, type SelectEntry } from '#components/Select'
import { useIsLanguageControlled } from '#i18n/ControlLanguageModule'
import { isDebugI18n } from '#i18n/i18n'
import { sharedTestIds } from '#utils/sharedTestIds'

const useTranslatedLanguageEntries = (isLanguageControlled?: boolean) => {
  const { t } = useTranslation('shared')
  const languages: SelectEntry[] = [
    { id: 'en', value: t('lang.english', 'English') },
    { id: 'de', value: t('lang.german', 'German') },
    { id: 'it', value: t('lang.italian', 'Italian') },
  ]

  if (isDebugI18n) {
    languages.push({ id: 'dev', value: t('lang.english-dev', 'English (Dev)') })
    languages.push({ id: 'pseudo', value: t('lang.pseudo', 'Pseudo') })
    languages.push({ id: 'keys', value: t('lang.keys', 'Only Keys') })
  }

  if (isLanguageControlled) {
    languages.push({ id: 'from-configuration', value: t('lang.from-configuration', 'From Configuration') })
  }

  return languages
}

export const LanguageSwitcher = ({ className }: { className?: string }) => {
  const { i18n, t } = useTranslation('shared')
  const isLanguageControlled = useIsLanguageControlled()
  const languages = useTranslatedLanguageEntries(isLanguageControlled)

  return (
    <Select
      // label={t('lang.select', 'Select Language')}
      className={className}
      options={languages}
      placeholder={t('lang.select', 'Select Language')}
      disabled={isLanguageControlled}
      value={isLanguageControlled ? 'from-configuration' : i18n.language}
      onChange={(item) => {
        i18n.changeLanguage(item).catch(console.error)
      }}
      slim
      data-testid={sharedTestIds.userSettings.languageSelect}
    />
  )
}
